/* Shared add-to-cart handler for the American Choice custom homepage sections. */
window.acAdd = window.acAdd || function (btn, id, qty, after) {
  if (!id) { window.location.href = '/cart'; return; }
  var old = btn.getAttribute('data-label') || btn.textContent;
  btn.setAttribute('data-label', old);
  btn.disabled = true;
  btn.classList.add('is-loading');
  btn.textContent = 'Adding…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
  })
    .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
    .then(function (res) {
      if (!res.ok) { throw new Error((res.d && res.d.description) || 'Could not add to cart'); }
      btn.textContent = 'Added ✓';
      if (after === 'checkout') { window.location.href = '/checkout'; return; }
      if (after === 'stay') {
        setTimeout(function () {
          btn.textContent = old; btn.disabled = false; btn.classList.remove('is-loading');
        }, 1400);
        return;
      }
      window.location.href = '/cart';
    })
    .catch(function (e) {
      btn.textContent = old; btn.disabled = false; btn.classList.remove('is-loading');
      alert(e.message || 'Sorry, that item could not be added.');
    });
};
